import { MarketLayoutNode, MarketSymbolItem, SortedSymbols } from '@flipster/apis/v2/market/types';

export interface MarketLayoutEntry {
  type: string;
  /** SortedSymbols(`data`) 키. 이 노드가 렌더할 심볼 목록의 출처.  */
  dataRef?: string;
}

export const flattenMarketLayout = (nodes: MarketLayoutNode[] | undefined): MarketLayoutEntry[] => {
  const entries: MarketLayoutEntry[] = [];
  const visit = (node: MarketLayoutNode) => {
    entries.push({ type: node.type, dataRef: node.dataRef });
    node.children?.forEach(visit);
  };
  nodes?.forEach(visit);
  return entries;
};

export const getSymbolsByDataRef = (data: SortedSymbols | undefined, dataRef: string | undefined): string[] => {
  if (!data || !dataRef) return [];
  const value: unknown = (data as unknown as Record<string, unknown>)[dataRef];
  if (!Array.isArray(value)) return [];
  return (value as readonly (string | MarketSymbolItem)[]).map((item) =>
    typeof item === 'string' ? item : item.symbol,
  );
};
